import environment from "../config/environment"

async function parseJsonSafe(response) {
  const text = await response.text()
  try {
    return text ? JSON.parse(text) : null
  } catch {
    return text
  }
}

export async function requestGeoFlowHandshakeCode(bearer) {
  const response = await fetch(environment.geoflow.handshake_url, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${bearer}`,
    },
  })

  if (!response.ok) {
    const errorBody = await parseJsonSafe(response)
    throw new Error(
      `Failed to request GeoFlow handshake code (${response.status}): ${JSON.stringify(errorBody)}`,
    )
  }

  return response.json()
}

export async function consumeGeoFlowHandshakeCode(geoflowBase, code) {
  const response = await fetch(`${geoflowBase}/auth/handshake/consume`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ code }),
  })

  if (!response.ok) {
    const errorBody = await parseJsonSafe(response)
    throw new Error(
      `Failed to consume GeoFlow handshake code (${response.status}): ${JSON.stringify(errorBody)}`,
    )
  }
}

// Handshake-Flow: Code mit USS-Token holen, beim GeoFlow-Service einlösen
// (setzt dort ein Session-Cookie), GeoFlow-Base-URL zurückgeben.
export async function ensureGeoFlowSession(bearer) {
  const { code, geoflow_base } = await requestGeoFlowHandshakeCode(bearer)
  const base = (environment.geoflow.base_override || geoflow_base).replace(
    /\/+$/,
    "",
  )
  await consumeGeoFlowHandshakeCode(base, code)
  return base
}
